Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("infographics")) {
        const infographics = new Vue({
            el: '#infographics',
            store,
            data: function () {
                return{
                    infographicContent: 1,
                    infographicCart: null,
                    flkty: null
                }
            },
            computed: {},
            mounted: function () {
                this.initializeFlickity();
            },
            watch: {
                infographicContent: function() {
                    this.flkty.select(infographics.infographicContent - 1 );
                }
            },
            methods: {
                toggleInfographic: function(int) {
                    infographics.infographicContent = int
                },

                setInfographicCart: function(int) {
                    infographics.infographicCart = int
                },

                initializeFlickity() {
                    this.flkty = new Flickity(this.$refs.infographicNav, {
                        watchCSS: true,
                        autoPlay: false,
                        pageDots: false,
                        prevNextButtons: false,
                        draggable: true,

                        on: {
                            change: function(index) {
                                infographics.infographicContent = index + 1
                            }
                        }
                    });
                }
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});